import PlanFavouriteCard from "../../components/PlanFavouriteCard"
import React, { useState, useEffect } from "react"
import Div100vh from "react-div-100vh"
import MarkIcon from "./mark.svg"
import RoomImg from "./room.jpg"
import LogoIcon from "./logo.svg"
// import EnvelopeLogoIcon from "./envelope_logo.svg"
import MapImg from "./map.jpg"
import { numbers } from "../Favourites/Favourites"

// import { ApartmentSheetURL } from "App"
import { ApartmentSheetURL } from "../../../src/App"

import "./ShareApartments.css"
import "./Envelope.css"
import { useStore } from "../../components/ApartmentFinder/State/Store"
// import { useStore } from "components/ApartmentFinder/State/Store"

export const getQueryString = (search = window.location.search, name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
  let r = search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export default function ShareApartments(props) {
  const [planData, setPlanData] = useState([])
  // const [openEnvelope, setOpenEnvelope] = useState(false)
  // const [showEnvelope, setShowEnvelope] = useState(false)
  const setIsShare = useStore(state => state.setIsShare)

  useEffect(() => {
    setIsShare(true)
    fetch(ApartmentSheetURL).then(response => {
      response.text().then(text => {
        const data = text.split("\r\n").map(line => line.split(","))
        const header = data[1]
        const apartmentsLines = data.slice(2)
        const apartments = []

        for (let line of apartmentsLines) {
          const apartment = {}
          for (let x = 0; x < line.length; x++) {
            apartment[header[x]] = line[x]
          }
          apartments.push(apartment)
        }

        const qs_plots =
          getQueryString(props.location.search, "units")
            .split(",")
            .filter(plot => plot) || []

        const favouriteApartments = apartments.filter(a =>
          qs_plots.includes(a.PlotNumber)
        )

        const filtereddata = favouriteApartments.map(apt => ({
          name: "slide_e",
          id: apt.PlotNumber,
          icon: "/assets/images/favourites/icon_apart_block_e.svg",
          floor_no: `${apt.FloorLevel}`,
          flatType: `${apt.FlatType}`,
          bathrooms: `${apt["No. Of Bathrooms (including ensuite)"]}`,
          apartment_no: `apartment ${apt.PlotNumber}`,
          beds: apt[`No. Of Double Bedrooms`],
          blockID: apt.PlotNumberPlanning.split(".")[0],
          bed_type: `${numbers[apt.Beds]} bed`,
          total_internal_area: `${apt["Sqm"]} sq m | ${apt["Sqft"]} sq ft`,
          total_external_area: `${apt["Sqm (Stage 4)"]} sq m | ${apt["Sqft (Stage 4)"]} sq ft`,
          rooms: [
            "Kitchen 4.7 x 2.1 m",
            "Living/Dining 5.5 x 4.2 m",
            "Master Bedroom 3.8 x 3.8 m",
            "Bedroom 2 4.3 x 2.9 m",
            "Bedroom 3 4.1 x 3.1 m",
            "Balcony 12 2.4 x 1.5 m"
          ]
        }))
        setPlanData(filtereddata)
        // setTimeout(() => {
        //   setOpenEnvelope(true)
        // }, 500)
        // setTimeout(() => {
        //   setShowEnvelope(true)
        // }, 1500)
      })
    })
    return () => setIsShare(false)
  }, [])

  return (
    <Div100vh className="share_apartments_container">
      {/* <div className="envelope">
        <input
          className="envelope__check"
          type="checkbox"
          checked={openEnvelope}
          onChange={() => {
            // setOpenEnvelope(!openEnvelope)
            // setShowEnvelope(false)
          }}
        />
        <div className="envelope__flap envelope__flap--inside"></div>
        <div className="envelope__flap">
          <div className="envelope__mark">
            <img src={MarkIcon} alt="" />
          </div>
          <div className="envelope__label_floor">
            <p>Your Select Floor Plans</p>
            <div></div>
          </div>
          <div className="envelope__logo">
            <img src={EnvelopeLogoIcon} alt="logo" />
          </div>
        </div>
      <div
        className={`envelope__letter ${
          showEnvelope ? "envelope__letter__show" : ""
        }`}
      > */}
      <div className="letter">
        <div className="letter__content">
          <div className="share_apartments">
            <div className="plans-header">
              <div className="icon-wrapper">
                <img src={MarkIcon} alt="navigation" />
              </div>
              <div className="title-wrapper">
                <span>Your Floor Plans</span>
              </div>
            </div>
            <div className="plans-container">
              {planData.map((d, index) => (
                <PlanFavouriteCard key={index} data={d} />
              ))}
            </div>
            <div className="home-container">
              <div className="gallery-image">
                <img src={RoomImg} alt="gallery" />
              </div>
              <div className="text-container">
                <div className="home">
                  <img src={LogoIcon} alt="" />
                </div>
                <div className="text-content">
                  It is a place that connects people, from those who live here
                  to the wider Leyton community. A home where you’ll feel a
                  connection to your surroundings in the bustling streetscapes,
                  beautifully designed landscaped spaces and amenities nearby.
                  More than a new landmark address, it’s a new way of city
                  living.
                </div>
              </div>
            </div>
            <div className="divider"></div>
            <div className="map-container">
              <img src={MapImg} alt="Map"></img>
            </div>
            <div className="divider"></div>
            <div className="footer-container">
              <div className="contact">
                <div
                  style={{
                    marginBottom: 20,
                    fontSize: 20,
                    fontWeight: "bold"
                  }}
                >
                  Contact:
                </div>
                <a href="mailto:coronationsquare@taylorwimpey.com">
                  <p>coronationsquare@taylorwimpey.com</p>
                </a>
                <p>020 3944 9106</p>
              </div>
              <div className="address">
                <div
                  style={{
                    marginBottom: 20,
                    fontSize: 20,
                    fontWeight: "bold"
                  }}
                >
                  Marketing Suite Address:
                </div>
                <p>
                  Coronation Square Sales Suite <br />
                  100 Oliver Rd
                  <br />
                  London
                  <br />
                  E10 5JY
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div>
        <div className="envelope__back">
          <div className="envelope__back__contact">
            <div>
              <p>
                <strong>Find us at:</strong>
              </p>
              <p>Coronation Square Sales Suite</p>
              <p>100 Oliver Rd</p>
              <p>London</p>
              <p>E10 5JY</p>
            </div>
            <div>
              <p>www.taylorwimpey/coronationsquare.co.uk</p>
              <p>E-mail: Coronation.Square@taylorwimpey.com</p>
              <p>Phone: 020 3944 9106</p>
            </div>
          </div>
        </div> 
      </div>*/}
    </Div100vh>
  )
}
